<template>
  <TransactionListTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/user'"
    :setLoading="setLoading"
    :persistenceKey="'user-list'"
    :backButtonEnable="true"
  />
</template>

<script>
import TransactionListTemplate from "../../../templates/transaction-list";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      validationSummary: [],
      setLoading: false,
      data: {
        title: "Users",
        pageRoute: "/users",
        exportFileName: "User List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ApplicationUserList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "user",
              mode: "review",
              idProperty: "ApplicationUserCode",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/user/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Username",
              gridDataField: "ApplicationUserCode",
              dataField: "ApplicationUserCode",
              allowHiding: false,
              sortOrder: "asc",
              sortIndex: 0,
              label: "Username",
            },
            {
              screenField: "ApplicationUserType",
              dataField: "ApplicationUserTypeCode",
              gridDataField: "ApplicationUserTypeCode",
              filterDataField: "ApplicationUserTypeCode",
              label: "License Type",
              filterLabel: "License Type",
              filterIndex: 1,
            },
            {
              screenField: "Role",
              dataField: "RoleList",
              gridDataField: "RoleList",
              filterDataField: "RoleList",
              label: "Roles",
              filterIndex: 2,
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
              filterDefaultValue: ["N"],
            },
          ],
        },
      },
    };
  },
  computed: {},
  methods: {},
};
</script>
